import { render, staticRenderFns } from "./contatoEditar.vue?vue&type=template&id=c0a4c48c&scoped=true&"
import script from "./contatoEditar.vue?vue&type=script&lang=js&"
export * from "./contatoEditar.vue?vue&type=script&lang=js&"
import style0 from "./contatoEditar.vue?vue&type=style&index=0&id=c0a4c48c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a4c48c",
  null
  
)

export default component.exports